import React from 'react';
import './styles/News.css';

const newsItems = [
    {
        title: 'Program available for the 2025 Workshop on Teaming up with social artificial agents',
        date: '22 September 2025, Centro Congressi Le Benedettine, Pisa, Italy',
        description: 'Join us for an exciting workshop where our team will present the latest research and advancements in artificial intelligence and human-agent collaboration. This workshop will be held at Centro Congressi Le Benedettine and will feature talks, interactive sessions, and networking opportunities.',
        program: {
            days: [
                {
                    title: 'Day 1: Monday 22 September',
                    sessions: [
                        { time: '10:00', speaker: 'Piero Ronzani', title: 'Irrational herding persists in human-bot interactions' },
                        { time: '10:30', speaker: 'Jonathan Winter', title: 'The Commitment Gap: Why Humans Underperform with AI Teammates' },
                        { time: '11:00', type: 'break', title: 'Coffee break' },
                        { time: '11:30', speaker: 'Levin Brinkmann', title: 'Partners, Teachers, and Governors: Interacting with Strategic Artificial Agents', isKeynote: true },
                        { time: '12:30', type: 'break', title: 'Lunch' },
                        { time: '14:00', speaker: 'Lorenzo Cominelli', title: 'Social Artificial Players in Teams' },
                        { time: '14:30', speaker: 'Maria Bigoni', title: 'Coordination and Leadership: the impact of Artificial Intelligence' },
                        { time: '15:00', type: 'break', title: 'Coffee break' },
                        { time: '15:30', speaker: 'Omar Mazzucchelli', title: 'Trust in Artificial Intelligence and Stakeholder Inclusion in Innovation Processes: An Experimental Approach' },
                        { time: '16:00', type: 'activity', title: 'Visit to ABEL' }
                    ],
                    evening: 'Social Dinner by invitation'
                },
                {
                    title: 'Day 2: Tuesday 23 September',
                    sessions: [
                        { time: '9:30', type: 'discussion', title: 'Project Proposal Discussion' },
                        { time: '12:30', type: 'end', title: 'End Workshop' }
                    ]
                }
            ]
        },
        image: `${process.env.PUBLIC_URL}/images/workshoplogo.jpg`
    },
    // Add more news items here as needed
];

function News() {
    const renderSession = (session, index) => {
        if (session.type === 'break') {
            return (
                <div key={index} className="program-break">
                    <span className="program-time">{session.time}</span>
                    <span className="program-break-title">{session.title}</span>
                </div>
            );
        }

        if (session.type === 'activity' || session.type === 'discussion' || session.type === 'end') {
            return (
                <div key={index} className="program-activity">
                    <span className="program-time">{session.time}</span>
                    <span className="program-activity-title">{session.title}</span>
                </div>
            );
        }

        return (
            <div key={index} className={`program-session ${session.isKeynote ? 'keynote' : ''}`}>
                <span className="program-time">{session.time}</span>
                <div className="program-content">
                    <span className="program-speaker">{session.speaker}</span>
                    <span className="program-title">"{session.title}"</span>
                    {session.isKeynote && <span className="keynote-label">Keynote</span>}
                </div>
            </div>
        );
    };

    return (
        <div className="news-container">
            <h1 className="news-title">Latest News</h1>
            <div className="news-grid">
                {newsItems.map((item, index) => (
                    <div className="news-card" key={index}>
                        <img src={item.image} alt={item.title} className="news-image" />
                        <div className="news-content">
                            <h2 className="news-item-title">{item.title}</h2>
                            <p className="news-date">{item.date}</p>
                            <p className="news-description">{item.description}</p>

                            {item.program && (
                                <div className="program-container">
                                    <h3 className="program-heading">Program</h3>
                                    {item.program.days.map((day, dayIndex) => (
                                        <div key={dayIndex} className="program-day">
                                            <h4 className="program-day-title">{day.title}</h4>
                                            <div className="program-sessions">
                                                {day.sessions.map((session, sessionIndex) =>
                                                    renderSession(session, sessionIndex)
                                                )}
                                            </div>
                                            {day.evening && (
                                                <div className="program-evening">
                                                    <strong>{day.evening}</strong>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default News;